import React from 'react'
import styled from 'styled-components'
import ButtonTC from '../../../components/button-tc/button-tc'
import { device } from '../../../config/theme/breakpoints'
import AlertInfoAccount from './alert-info-account/alert-info-account'
import FeatureItem from './feature-item/feature-item'

const ContainerInfoHeader = styled.div`
    background: ${p => p.theme.palette.primary.main};
    border-radius: 12px;
    padding: 40px;
    display: flex;
    margin-top: 20px;
    margin-bottom: 20px;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    @media ${device.tablet}{
        flex-direction: row;
    }
`

const ContainerInicial = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 20px;

    > div:nth-child(1) {
        padding: 5px;
        border-radius: 50%;
        background: rgb(255 255 255 / 40%);
    }
    
    > div div { 
        min-width: 100px;
        min-height: 100px;
        width: 100%;
        height: 100%;
        background: white;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 20px;
        border-radius: 50%;
        border: 2px solid ${p => p.theme.palette.secondary.main};
    }

    > div div span {
        font-size: 35px;
        color: ${p => p.theme.palette.text.grayLight};
    }
`
const ContainerInfo = styled.div`
    color: white;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`
const ContainerFeatures = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 15px;
`

const MainAccount: React.FunctionComponent = () => {
  return (
    <>
        <AlertInfoAccount />
        <ContainerInfoHeader>
            <ContainerInicial>
                <div>
                    <div>
                        <span>MZ</span>
                    </div>
                </div>
            </ContainerInicial>
            <ContainerInfo>
                <div>
                    <h3>Miguel Angel Zicia Osorio</h3>
                    <p>Nº de socio <b>51434768326</b> | Categoría <b>PREMIUM</b></p>
                </div>
                <div>
                    <ButtonTC text='Actualizar datos' buttonStyle='secondary'/>
                </div>
            </ContainerInfo>
        </ContainerInfoHeader>
        <ContainerFeatures>
            <FeatureItem title='Revisa' fragmentTitle='tus últimos viajes' description='Ingresa tu número de documento y la clave señaladas en el comprobante que se te entregó al momento de enviar tu encomienda para poder realizar seguimiento de tus envíos.' />
            <FeatureItem title='Revisa' fragmentTitle='tus últimos viajes' description='Ingresa tu número de documento y la clave señaladas en el comprobante que se te entregó al momento de enviar tu encomienda para poder realizar seguimiento de tus envíos.' />
            <FeatureItem title='Revisa' fragmentTitle='tus últimos viajes' description='Ingresa tu número de documento y la clave señaladas en el comprobante que se te entregó al momento de enviar tu encomienda para poder realizar seguimiento de tus envíos.' />
            <FeatureItem title='Revisa' fragmentTitle='tus últimos viajes' description='Ingresa tu número de documento y la clave señaladas en el comprobante que se te entregó al momento de enviar tu encomienda para poder realizar seguimiento de tus envíos.' />
        </ContainerFeatures>
    </>
  )
}

export default MainAccount